// Angular libray
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

// Local library
import { UnsubscribeObservableService,
TranslatePipe
} from '@amwager/util';

// Third party
import { Subscription, takeUntil } from 'rxjs';

// Local library
import { DepositMoneyPakService } from '@amwager/funding/data-access';

@Component({
  selector: 'feature-mat-money-pak',
  templateUrl: './money-pak.component.html',
  styleUrls: ['./money-pak.component.scss'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslatePipe
  ],
  standalone: true,
  providers: [DepositMoneyPakService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MoneyPakComponent extends UnsubscribeObservableService implements OnInit {

  moneyPakForm!: FormGroup;

  // convenience getter for easy access to form fields
  get formVal() { return this.moneyPakForm?.controls }

  moneyPakNumber!: string;

  private subsDepositMoneyPakResponse!: Subscription;

  isDepositing = false;
  isOnline: boolean = true;

  constructor(
    private readonly cdRef: ChangeDetectorRef,
    private readonly moneyPakService: DepositMoneyPakService,
  ) {
    super();
  }

  ngOnInit() {
    this.checkConnectivity();

    // OLD (moved to DepositMoneyPakService.buildForm):
    // this.initForm();
    this.moneyPakForm = this.moneyPakService.buildForm();

    this.formVal['moneyPakNumber']?.setValue('');
    this.moneyPakNumber = '';
  }

  depositAmount(): void {
    this.moneyPakNumber = this.formVal['moneyPakNumber']?.value;
  }

  deposit(): void {
    if (!this.isOnline) {
      // OLD (moved to DepositMoneyPakService.setOffline):
      // this.commonFacade.setIsConnectedInternet('MoneyPakComponent:deposit', false);
      this.moneyPakService.setOffline('MoneyPakComponent:deposit');
      return;
    }

    if (this.moneyPakForm.valid && this.moneyPakNumber) {
      this.isDepositing = true;

      // OLD (dispatch + success stream moved to DepositMoneyPakService.deposit$):
      // this.fundingFacade.depositMoneyPak(this.moneyPakNumber);
      // this.subsDepositMoneyPakResponse = this.fundingFacade.isDepositMoneyPakSuccess$()
      this.subsDepositMoneyPakResponse = this.moneyPakService.deposit$(this.moneyPakNumber)
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe(({response, isSuccess}) => {
        if (!isSuccess && response !== undefined) {
          const errMsg = response?.Message ? response.Message : 'Invalid Moneypak Number';
          this.showAlertMessage('Deposit Error', errMsg);
          this.isDepositing = false;
          this.cdRef.markForCheck();
        }

        this.subsDepositMoneyPakResponse?.unsubscribe();

        if (isSuccess) {
          this.showAlertMessage('Successful Deposit', 'Successfully Deposited Amount');
          this.moneyPakForm.reset();
          this.isDepositing = false;
          this.cdRef.markForCheck();
        }
      });
    }
    else {
      // OLD (moved to DepositMoneyPakService.markFormGroupTouched):
      // this.fundingService.markFormGroupTouched(this.moneyPakForm);
      this.moneyPakService.markFormGroupTouched(this.moneyPakForm);
    }
  }

  showAlertMessage(header: string, message: string): void {
    // OLD (moved to DepositMoneyPakService.showAlert):
    // this.matNotificationService.showAlert(header, message, undefined, undefined, 'Close');
    this.moneyPakService.showAlert(header, message);
  }

  checkConnectivity(): void {
    // OLD (moved to DepositMoneyPakService.checkConnectivity):
    // this.fundingService.checkConnectivity(
    //   this.environment,
    //   'MoneyPakComponent:checkConnectivity',
    //   (online: boolean) => this.isOnline = online
    // );
    this.moneyPakService.checkConnectivity(
      'MoneyPakComponent:checkConnectivity',
      (online: boolean) => this.isOnline = online
    );
  }

}
